<div class="fixed inset-0 z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-zinc-950/25 dark:bg-zinc-950/50 backdrop-blur-sm transition-opacity" (click)="onCloseModal()"
        aria-hidden="true"></div>

    <!-- Slide-over Panel -->
    <div class="fixed inset-y-0 right-0 flex max-w-full py-4 pr-4 pl-4 sm:pl-8">
        <div class="w-screen max-w-md">
            <div
                class="flex h-full flex-col overflow-hidden rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">

                <!-- Header -->
                <div
                    class="flex items-center justify-between gap-3 border-b border-zinc-950/10 px-4 py-3 dark:border-white/10">
                    <div class="flex items-center gap-2">
                        <h3 class="text-base font-semibold text-zinc-950 dark:text-white" id="slide-over-title">
                            Notifications</h3>
                        <span *ngIf="unreadCount > 0" class="badge-primary">
                            {{ unreadCount }} unread
                        </span>
                    </div>
                    <div class="flex items-center gap-3">
                        <button *ngIf="unreadCount > 0 || hasUnreadNotifications()"
                            type="button"
                            (click)="onMarkAllAsRead()"
                            class="text-xs font-medium text-blue-600 hover:text-blue-700 dark:text-blue-400 hover:underline cursor-pointer transition-colors">
                            Mark all as read
                        </button>
                        <button type="button" (click)="onCloseModal()"
                            class="rounded-lg p-1.5 text-zinc-500 hover:bg-zinc-950/5 hover:text-zinc-950 dark:text-zinc-400 dark:hover:bg-white/5 dark:hover:text-white">
                            <span class="sr-only">Close panel</span>
                            <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- Web Push Notification Settings Section -->
                <div class="p-3 border-b border-zinc-950/10 dark:border-white/10 bg-zinc-50 dark:bg-zinc-900/50">
                    <div class="flex items-center justify-between gap-2 mb-2">
                        <div class="flex items-center gap-2">
                            <div class="p-1.5 rounded-md bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-400">
                                <svg xmlns="http://www.w3.org/2000/svg" class="size-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                                </svg>
                            </div>
                            <div>
                                <h4 class="text-xs font-semibold text-zinc-900 dark:text-white">Desktop Push Notifications</h4>
                                <p class="text-[11px] text-zinc-500 dark:text-zinc-400">
                                    Receive alerts when your driver arrives or trips update
                                </p>
                            </div>
                        </div>

                        <!-- Status Badge -->
                        <span *ngIf="isPushSubscribed" class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300">
                            Active
                        </span>
                        <span *ngIf="!isPushSubscribed && permissionStatus === 'denied'" class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-300">
                            Blocked
                        </span>
                        <span *ngIf="!isPushSubscribed && permissionStatus !== 'denied'" class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium bg-zinc-200 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300">
                            Off
                        </span>
                    </div>

                    <!-- Blocked permission warning note -->
                    <div *ngIf="permissionStatus === 'denied'" class="mb-2 p-2 rounded bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/50 text-[11px] text-amber-800 dark:text-amber-300">
                        <span class="font-medium">Notifications are blocked in Chrome:</span> Click the tune icon in the browser address bar and set Notifications to <b>Allow</b>.
                    </div>

                    <!-- Action Buttons -->
                    <div class="flex items-center gap-2 mt-2">
                        <button *ngIf="!isPushSubscribed" 
                            type="button"
                            [disabled]="isPushLoading || !isPushSupported"
                            (click)="toggleWebPush()"
                            class="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 transition-colors shadow-sm">
                            <span *ngIf="isPushLoading" class="animate-spin size-3 border-2 border-white border-t-transparent rounded-full"></span>
                            <span>Enable Chrome Notifications</span>
                        </button>

                        <button *ngIf="isPushSubscribed" 
                            type="button"
                            [disabled]="isPushLoading"
                            (click)="toggleWebPush()"
                            class="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md text-zinc-700 bg-white dark:bg-zinc-800 dark:text-zinc-200 border border-zinc-300 dark:border-zinc-700 hover:bg-zinc-100 dark:hover:bg-zinc-700 disabled:opacity-50 transition-colors">
                            <span *ngIf="isPushLoading" class="animate-spin size-3 border-2 border-zinc-500 border-t-transparent rounded-full"></span>
                            <span>Disable Push</span>
                        </button>

                        <button *ngIf="isPushSubscribed"
                            type="button"
                            [disabled]="isPushLoading"
                            (click)="sendTestPush()"
                            class="inline-flex items-center justify-center gap-1 px-3 py-1.5 text-xs font-medium rounded-md text-blue-600 bg-blue-50 dark:bg-blue-950/60 dark:text-blue-300 border border-blue-200 dark:border-blue-900 hover:bg-blue-100 dark:hover:bg-blue-900/80 transition-colors">
                            <span>Test Push</span>
                        </button>
                    </div>
                </div>

                <!-- Tabs -->
                <div class="flex items-center gap-2 border-b border-zinc-950/10 px-3 py-2 dark:border-white/10">
                    <button *ngFor="let tab of categoryTabs" type="button" (click)="onSelectCategory(tab.value)"
                        [ngClass]="category === tab.value ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'">
                        {{tab.label}}
                    </button>
                </div>

                <!-- List -->
                <div class="flex-1 overflow-y-auto">
                    <div *ngIf="!notifications.length" class="p-8">
                        <div
                            class="relative block w-full rounded-lg border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-12 text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="mx-auto h-12 w-12 text-zinc-400 dark:text-zinc-500">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25m-18 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6zM7.5 6h.008v.008H7.5V6zm2.25 0h.008v.008H9.75V6z" />
                            </svg>
                            <span class="mt-2 block font-medium text-zinc-500 dark:text-zinc-400">No notifications to
                                show</span>
                        </div>
                    </div>

                    <ul *ngIf="notifications.length" role="list" class="space-y-2 p-3">
                        <li *ngFor="let notification of notifications">
                            <button type="button" (click)="onNotificationClick(notification)"
                                class="flex w-full items-start gap-3 rounded-lg border p-3 text-left transition-all duration-150 hover:shadow-sm"
                                [ngClass]="notification.isRead
                                    ? 'border-zinc-200/80 bg-zinc-50/50 hover:bg-zinc-100/70 dark:border-zinc-800/80 dark:bg-zinc-900/40 dark:hover:bg-zinc-900/80'
                                    : 'border-l-4 border-l-blue-600 border-blue-200/80 bg-blue-50/80 hover:bg-blue-100/70 shadow-sm dark:border-l-blue-500 dark:border-blue-900/60 dark:bg-blue-950/40 dark:hover:bg-blue-950/70'">
                                <div class="min-w-0 flex-1">
                                    <div class="flex items-start justify-between gap-2">
                                        <div class="flex items-center gap-1.5 min-w-0">
                                            <p class="truncate text-sm"
                                                [ngClass]="notification.isRead ? 'font-medium text-zinc-600 dark:text-zinc-400' : 'font-semibold text-zinc-950 dark:text-white'">
                                                {{ notification?.title | titlecase }}
                                            </p>
                                        </div>
                                        <div class="flex items-center gap-1.5 shrink-0">
                                             <span *ngIf="!notification.isRead"
                                                 class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-blue-100 text-blue-700 dark:bg-blue-900/60 dark:text-blue-300">
                                                 <span class="size-1.5 rounded-full bg-blue-600 dark:bg-blue-400"></span>
                                                 New
                                             </span>
                                             <span *ngIf="notification.isRead"
                                                 class="inline-flex items-center text-[10px] font-medium text-zinc-400 dark:text-zinc-500">
                                                 Read
                                             </span>
                                        </div>
                                    </div>
                                    <p class="mt-1 line-clamp-2 text-xs"
                                        [ngClass]="notification.isRead ? 'text-zinc-500 dark:text-zinc-400' : 'text-zinc-700 dark:text-zinc-200 font-medium'">
                                        {{ notification.message }}
                                    </p>
                                    <div class="mt-2 flex items-center gap-2">
                                        <span class="text-[11px]"
                                            [ngClass]="notification.isRead ? 'text-zinc-400 dark:text-zinc-500' : 'text-blue-600 dark:text-blue-400 font-medium'">
                                            {{ getRelativeTime(notification.createdAt) }}
                                        </span>
                                    </div>
                                </div>
                            </button>
                        </li>
                    </ul>
                </div>

                <!-- Footer -->
                <div class="border-t border-zinc-950/10 px-4 py-3 dark:border-white/10">
                    <button [routerLink]="['/notifications']" (click)="closeModal.emit(false)"
                        routerLinkActive="router-link-active" class="btn btn-secondary w-full">
                        All Notifications
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>